import styles from './Loader.less';

import React from 'react';

export default class Loader extends React.Component {

  render() {
    return (
      <div className={styles.root}>
        <div className={styles.ball} />
        <div className={styles.ball} />
        <div className={styles.ball} />
      </div>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Loader/Loader.js
 **/